<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="工號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empNo">
              <a-input v-model="model.empNo" placeholder="请输入工號"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="站點code" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="webSiteCode">
              <a-input v-model="model.webSiteCode" placeholder="请输入站點code"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="站點url" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="webSiteUrl">
              <a-input v-model="model.webSiteUrl" placeholder="请输入站點url"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="資料來源" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="fromSource">
              <a-input v-model="model.fromSource" placeholder="请输入資料來源"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" placeholder="请输入备注"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="進入歷史表時間" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="historyTime">
              <j-date placeholder="请选择進入歷史表時間" v-model="model.historyTime" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="進入歷史表備註" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="historyRemark">
              <a-input v-model="model.historyRemark" placeholder="请输入進入歷史表備註"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpWebsiteMappingHistoryForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           empNo: [
              { required: true, message: '请输入工號!'},
           ],
           fromSource: [
              { required: true, message: '请输入資料來源：dhr!'},
           ],
           delFlag: [
              { required: true, message: '请输入刪除标示!'},
           ],
        },
        url: {
          add: "/hhemp/sitemappinghis/empwebsitemappinghistory",
          edit: "/hhemp/sitemappinghis/empwebsitemappinghistory",
          queryById: "/hhemp/sitemappinghis/empwebsitemappinghistory/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
